import React from 'react';
import { Button, Col, Form, Input, Row, Typography } from 'antd';
import AuthLayout from '../../../Layout/AuthLayout';
import { getRoutes } from '../../../constants/Routes';
import { registerUser } from '../../../redux/actions/auth';
import { useNavigate } from 'react-router-dom';
import { sendNewAccountEmail } from '../../../redux/actions/email';

const Register = () => {
  const navigate = useNavigate();
  const handleRegister = async (values) => {
    const { confirmPassword, ...body } = values;
    const res = await registerUser(body, { isFetch: false });
    if (res?.ack) {
      const payload = {
        userEmail: values?.email,
        user: {
          first_name: values?.first_name,
          last_name: values?.last_name ?? ''
        }
      }
      sendNewAccountEmail(payload)
      navigate(getRoutes().login.route());
    }
  };

  return (
    <AuthLayout className="register" title="Create an Account" subtitle="Sign up to get started">
      <Form
        name="register"
        layout="vertical"
        className="Register__Form"
        onFinish={handleRegister}
        size="large"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[{ required: true, message: "Please enter the user's first name!" }]}
            >
              <Input placeholder="First Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Last Name" name="last_name">
              <Input placeholder="Last Name" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Please enter your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>

        <Form.Item
          label="Phone No."
          name="phone"
        >
          <Input placeholder="Phone Number" />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: 'Please create a password!' },
                { min: 6, message: 'Password must be at least 6 characters!' },
              ]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please confirm your password!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The confirm password do not match!'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm Password" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" block className="Register__Button">
            Register
          </Button>
        </Form.Item>
      </Form>

      <Typography.Paragraph className="Register__Login">
        Already have an account?{' '}
        <a href={getRoutes().login.route()} className="Register__LoginLink">
          Log in here
        </a>
      </Typography.Paragraph>
    </AuthLayout>
  );
};

export default Register;
